const EXACT_ALLOWED_PATHS = new Set([
  "/",
  "/redeem",
  "/redeem-success",
  "/profile",
  "/edit-profile",
  "/create-profile",
  "/create-profile-standalone",
  "/profile/manage-payments",
  "/exam-selection-standalone",
  "/exam-outcome",
  "/unsubscribe",
]);

const PREFIX_ALLOWED_PATHS = [
  "/sign-in",
  "/sign-up",
  "/organizations",
  "/distribute",
  "/refer",
];

export function isMobileWebAllowedPath(pathname: string) {
  const normalizedPathname =
    pathname.length > 1 ? pathname.replace(/\/+$/, "") || "/" : pathname;

  if (EXACT_ALLOWED_PATHS.has(normalizedPathname)) {
    return true;
  }

  return PREFIX_ALLOWED_PATHS.some(
    (path) =>
      normalizedPathname === path || normalizedPathname.startsWith(`${path}/`)
  );
}
